import { LEGAL_PAGE_SPECIFIC_DATA_LAYER_SESSION_STORAGE_KEYS } from './constants';
export const updatePageSpecificDataLayer = (resolvedUrl: string) => {
  const pageSpecificDataLayerKeys = sessionStorage.getItem(LEGAL_PAGE_SPECIFIC_DATA_LAYER_SESSION_STORAGE_KEYS);
  const allowedkeys = ['contact_topic', 'contact_prop_marsha_code', 'contact_subtopic'];

  /* The incoming URL may have a ".mi" suffix (e.g., "/marriott/confirmation.mi") or a locale prefix (e.g., "/fr/marriott/confirmation.mi").
     Due to NGINX and AEM Dispatcher, these suffixes or prefixes are stripped before the request reaches Next.js.
     As a result, the `resolvedUrl` received in this function from preProcessor call is a simplified form (e.g., "/marriott/confirmation"). */

  if (resolvedUrl === '/marriott/confirmation' && pageSpecificDataLayerKeys) {
    if (window?.dataLayer) {
      const pageSpecificDataLayerKeysData = JSON.parse(pageSpecificDataLayerKeys);
      for (const key of Object.keys(pageSpecificDataLayerKeysData)) {
        if (allowedkeys.includes(key)) {
          window.dataLayer[key] = pageSpecificDataLayerKeysData[key];
        }
      }
    }
    return;
  }
  sessionStorage.removeItem(LEGAL_PAGE_SPECIFIC_DATA_LAYER_SESSION_STORAGE_KEYS);
};
